import { render, staticRenderFns } from "./advertising-series.vue?vue&type=template&id=cb24db94&scoped=true"
import script from "./advertising-series.vue?vue&type=script&lang=js"
export * from "./advertising-series.vue?vue&type=script&lang=js"
import style0 from "./advertising-series.vue?vue&type=style&index=0&id=cb24db94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb24db94",
  null
  
)

export default component.exports